export const IMAGE_PREVIEW_ZOOM_MIN = 0.25;
export const IMAGE_PREVIEW_ZOOM_MAX = 5;

export type ImagePreviewOffset = { x: number; y: number };
export type ImagePreviewSize = { width: number; height: number };

export function clampImagePreviewZoom(zoom: number): number {
  return Math.min(IMAGE_PREVIEW_ZOOM_MAX, Math.max(IMAGE_PREVIEW_ZOOM_MIN, zoom));
}

export function imagePreviewZoomFromWheel(currentZoom: number, deltaY: number): number {
  return clampImagePreviewZoom(currentZoom * Math.exp(-deltaY * 0.003));
}

export function clampImagePreviewOffset(
  offset: ImagePreviewOffset,
  zoom: number,
  imageSize: ImagePreviewSize,
  viewportSize: ImagePreviewSize
): ImagePreviewOffset {
  const maxX = Math.max(0, (imageSize.width * zoom - viewportSize.width) / 2);
  const maxY = Math.max(0, (imageSize.height * zoom - viewportSize.height) / 2);
  return {
    x: maxX === 0 ? 0 : Math.min(maxX, Math.max(-maxX, offset.x)),
    y: maxY === 0 ? 0 : Math.min(maxY, Math.max(-maxY, offset.y))
  };
}
